// extracted by mini-css-extract-plugin
export default {"logo_header_wrapper":"Header_logo_header_wrapper__LGk9S","dropdown":"Header_dropdown__dpru8","araby":"Header_araby__VLBuk"};